import { REQUEST_PAGE, RECEIVE_PAGE } from 'page/actions';
import { SET_SPORTS_FILTER } from 'schedule/actions';
import { ADS_CONFIG, ADS_INITIALIZED, ADS_CONFIG_INVALIDATED, ADS_REFRESHED } from '../actions';

export default function adsReducer(state = { configured: false, initialized: false }, action) {
    switch (action.type) {
        case ADS_CONFIG:
            return { ...state, id: action.id, config: action.config, configured: true, initialized: false };

        case ADS_CONFIG_INVALIDATED:
            return { ...state, id: null, configured: false, initialized: false };

        case ADS_INITIALIZED:
            return { ...state, initialized: true };

        case REQUEST_PAGE:
            return { ...state, id: null, configured: false, initialized: false };

        case RECEIVE_PAGE:
            return { ...state, id: action.id };

        case SET_SPORTS_FILTER:
            return {
                ...state,
                config: { ...state.config, kvps: { ...state.config.kvps, sp: action.label.toLowerCase() } },
                refresh: true
            };

        case ADS_REFRESHED:
            return { ...state, refresh: false };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/ads/reducers/index.js